
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 1000 1000"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M500 10C236.3 10 22.6 229.4 22.6 500S236.4 990 500 990c263.7 0 477.4-219.4 477.4-490S763.7 10 500 10zm143.3 930.1c-23 4.6-31.1-9.9-31.1-22.3 0-15.2.5-65.2.5-127.2 0-43.3-14.5-71.6-30.7-86 100.8-11.4 206.5-50.7 206.5-228.8 0-50.6-17.5-92.1-46.5-124.5 4.6-11.7 20.2-58.8-4.5-122.7 0 0-37.9-12.5-124.3 47.6-36.1-10.3-74.8-15.5-113.2-15.7-38.5.2-77.2 5.3-113.2 15.7-86.4-60-124.4-47.6-124.4-47.6-24.6 63.9-9.1 111-4.4 122.7-28.9 32.4-46.5 73.8-46.5 124.5 0 177.7 105.6 217.5 206 229.2-12.9 11.6-24.6 32-28.7 62-25.8 11.8-91.3 32.3-131.6-38.6 0 0-23.9-44.5-69.3-47.8 0 0-44.2-.6-3.1 28.2 0 0 29.7 14.2 50.2 67.8 0 0 26.6 90.2 152.4 62.2.2 38.7.6 67.9.6 78.9 0 12.3-8.2 26.6-30.9 22.3C177.3 878.7 47.8 704.9 47.8 500 47.7 244 250.2 36.4 500 36.4c249.8 0 452.3 207.6 452.3 463.8 0 204.8-129.5 378.5-309 439.9z"}})])
          )
        }
      }
    